import { Box, Tab, Tabs, useMediaQuery } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function a11yProps(index: number) {
  return {
    id: `salary-main-tab-${index}`,
    "aria-controls": `salary-main-tabpanel-${index}`,
  };
}

const TAB_PATHS = [
  "/salary/employees",
  "/salary/salaries",
] as const;

const SalaryMainTabs = () => {
  const { t } = useTranslation("salary");
  const navigate = useNavigate();
  const location = useLocation();
  const isSmallScreen = useMediaQuery("(max-width:700px)");

  const labels = [
    t("employees"),
    t("salaries"),
  ];

  const currentPath = location.pathname;
  const resolvedIndex = currentPath.startsWith("/salary/employees")
    ? 0
    : TAB_PATHS.indexOf(currentPath as (typeof TAB_PATHS)[number]);
  const [value, setValue] = useState(resolvedIndex === -1 ? 0 : resolvedIndex);

  useEffect(() => {
    if (currentPath.startsWith("/salary/employees")) {
      setValue(0);
      return;
    }
    const idx = TAB_PATHS.indexOf(currentPath as (typeof TAB_PATHS)[number]);
    if (idx !== -1) {
      setValue(idx);
    }
  }, [currentPath]);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    navigate(TAB_PATHS[newValue]);
  };

  return (
    <Box
      bgcolor="#F9FAFB"
      p={0.5}
      border="1px solid #EAECF0"
      borderRadius={1}
      width={{ xs: "100%", md: "fit-content" }}
      display="flex"
      justifyContent={isSmallScreen ? "center" : ""}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        TabIndicatorProps={{ style: { display: "none" } }}
        orientation={isSmallScreen ? "vertical" : "horizontal"}
        sx={{
          minHeight: { xs: "100%", md: "35px" },
          height: { xs: "100%", md: "35px" },
        }}
      >
        {labels.map((label, index) => (
          <Tab
            key={index}
            disableRipple
            sx={{
              borderRadius: "6px",
              color: "#667085",
              height: "33px",
              minHeight: "33px",
              "&.Mui-selected": {
                bgcolor: "#FFFFFF",
                color: "#344054",
                boxShadow: "0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
                m: "1px",
              },
            }}
            label={label}
            {...a11yProps(index)}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default SalaryMainTabs;
